/**
 * TealerLab — Deferred perf scripts (extracted from tlr-head inline).
 * - Lazy-load img Klaviyo/Loyoly/Pushowl injectées au runtime
 * - Tealer Run pending claim finalize
 */
(function () {
  'use strict';

  // ── PERF: force lazy-loading sur les img Klaviyo/Loyoly/Pushowl
  (function () {
    var THIRD_PARTY_HOSTS = ['cloudfront.net/company', 'assets.loyoly.io', 'assets.klaviyo.com', 'static.klaviyo.com', 'pushowl'];
    function patchImg(img) {
      if (!img || img.dataset.tlrLazied) return;
      var src = img.src || img.getAttribute('data-src') || '';
      var matchesHost = THIRD_PARTY_HOSTS.some(function (h) { return src.indexOf(h) > -1; });
      var matchesParent = img.closest && img.closest('[class*="kl-"], [class*="klaviyo"], [class*="loyoly"], [class*="pushowl"], [class*="lds-"]');
      if (matchesHost || matchesParent) {
        img.loading = 'lazy';
        img.decoding = 'async';
        img.fetchPriority = 'low';
        img.dataset.tlrLazied = '1';
      }
    }
    document.querySelectorAll('img').forEach(patchImg);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.tagName === 'IMG') patchImg(n);
          else if (n.querySelectorAll) n.querySelectorAll('img').forEach(patchImg);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();

  // ── Tealer Run pending claim finalize (Tokyo freebie)
  (function () {
    var KEY = 'tlr_run_tokyo_pending';
    function readPending() {
      try {
        var raw = sessionStorage.getItem(KEY);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (!data || !data.aca || (Date.now() - (data.ts || 0)) > 86400000) {
          sessionStorage.removeItem(KEY);
          return null;
        }
        return data;
      } catch (_) { return null; }
    }
    function maybeFinalize() {
      var pending = readPending();
      if (!pending) return;
      fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
        var total = c.total_price || 0;
        if (total < 100) return;
        sessionStorage.removeItem(KEY);
        window.location.href = '/cart?aca=' + encodeURIComponent(pending.aca);
      }).catch(function () {});
    }
    document.addEventListener('cart:updated', function () { setTimeout(maybeFinalize, 600); });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setTimeout(maybeFinalize, 800); });
    } else {
      setTimeout(maybeFinalize, 800);
    }
  })();
})();
